import React, { useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import { triggerNotification } from '../../../helpers/notification';
import VendorSettingsView from './VendorSettingsView';
import VendorAdminViews from './VendorAdminViews';

const VendorSettingsViews = () => {
  const fetchedPkEcomVendor = useRef(null);
  const { state: authState } = useContext(AuthContext);
  const { state, fetchVendor } = useContext(VendorContext);

  const loading = !fetchedPkEcomVendor.current || state.ecomVendor.loading;
  const ecomVendor =
    fetchedPkEcomVendor.current?.toString() ===
    state.ecomVendor.value?.pkEcomVendor.toString()
      ? state.ecomVendor.value
      : null;

  useEffect(() => {
    if (
      authState.pkEcomVendor &&
      fetchedPkEcomVendor.current !== authState.pkEcomVendor
    ) {
      fetchVendor(authState.pkEcomVendor, null, (e) => triggerNotification(e));
      fetchedPkEcomVendor.current = authState.pkEcomVendor;
    }
  }, [authState.pkEcomVendor]);

  return (
    <Routes>
      <Route
        element={<VendorAdminViews ecomVendor={ecomVendor} loading={loading} />}
        path="/admins/*"
      />
      <Route
        element={
          <VendorSettingsView ecomVendor={ecomVendor} loading={loading} />
        }
        path="/"
      />
      <Route element={<Navigate replace to="/vendor/settings" />} path="*" />
    </Routes>
  );
};

export default VendorSettingsViews;
